import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import Typography from '@segment/matcha/components/Typography'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import { SectionWithAccordion } from 'views/Infrastructure/accordionData'

import AccordionSection from '../AccordionSection'

import AggregationProfileAPIImage from './AggregationProfileAPIImage'

const data = {
  anchorId: `profile-api`,
  overline: `Aggregation`,
  heading: `Profile API`,
  description: `Personalizing your website isn’t easy. You need millisecond response times to be able to get the page to load quickly. You need a full event history of your user. And you need to be able to make those decisions as the page is loading. Here’s how we do it.`,
  link: `https://www.youtube.com/watch?v=rECHcoGIJNU`,
  linkText: `Watch on Youtube (2,600 views)`,
  accordionSection: SectionWithAccordion.PROFILE_API,
}

const AggregationProfileAPI: FC<PropsWithChildren<unknown>> = () => {
  const { anchorId, overline, heading, description, link, linkText, accordionSection } = data
  return (
    <Wrapper id={anchorId}>
      <SectionBase variant="2Col" copyVariant="wide">
        <Section.Copy>
          <CopyTextBase>
            <CopyText.Overline>{overline}</CopyText.Overline>
            <CopyText.Heading>{heading}</CopyText.Heading>
            <CopyText.Description tag="div">
              <CopyTextDescriptionSection>{description}</CopyTextDescriptionSection>
              <CopyTextDescriptionSection>
                <Typography variant="pLarge">
                  <a href={link}>{linkText}</a>
                </Typography>
              </CopyTextDescriptionSection>
              <AccordionSection section={accordionSection} />
            </CopyText.Description>
          </CopyTextBase>
        </Section.Copy>
        <StyledSectionContents>
          <AggregationProfileAPIImage />
        </StyledSectionContents>
      </SectionBase>
    </Wrapper>
  )
}

const CopyTextDescriptionSection = styled.div`
  margin-bottom: 32px;
`

const Wrapper = styled.section`
  display: grid;
`

const StyledSectionContents = styled(Section.Contents)`
  margin: auto;
`

export default AggregationProfileAPI
